import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SV_STORE_COLLECTOR } from '@core/constants';
import {
  CollectionResponse,
  PaginationModel,
  PaymentCardModel,
  PaymentInfoModel,
  SingleItemResponse,
  StorePaymentModel,
  StoresModel,
} from '@core/models';
import { Api } from '@core/services/api.state';
import { ApiService } from '@core/services/api/api.service';
import { ExternalPaymentState } from '@core/state/external';
import { downloadFile } from '@core/utils';
import { environment } from '@rcsa-frontend/environments/environment';
import { Observable, map, tap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ExternalPaymentStoreService extends Api<StorePaymentModel> {
  override endpoint: string;

  constructor(
    protected override readonly apiService: ApiService<StorePaymentModel>,
    private externalPaymentState: ExternalPaymentState,
    private http: HttpClient
  ) {
    super(apiService);
    this.endpoint = `${environment.apiUrl}/v1/external/payments/payment-management/store/multiple`;
  }

  public multiplePayment(data: PaymentCardModel): Observable<PaymentInfoModel> {
    if (this.externalPaymentState.isFromSalvador) {
      const dataWithoutStoreCode = {
        ...data,
        id_pymnt_provider: SV_STORE_COLLECTOR,
        collection_notice_id:
          typeof data.collection_notice_id === 'string'
            ? [data.collection_notice_id]
            : data.collection_notice_id,
      };
      delete dataWithoutStoreCode.store_code;
      return this.http
        .post<SingleItemResponse<StorePaymentModel>>(
          `${environment.apiUrl}/v1/external/payments/payment-management/store-collector/multiple`,
          dataWithoutStoreCode
        )
        .pipe(
          map(
            (response: SingleItemResponse<StorePaymentModel>) => response.data
          )
        );
    }
    const params = JSON.stringify(data);
    return this.http
      .post<SingleItemResponse<StorePaymentModel>>(this.endpoint, params)
      .pipe(
        map((result) => {
          return result.data;
        })
      );
  }

  public printReference(id: string): Observable<any> {
    if (this.externalPaymentState.isFromSalvador) {
      const endpoint = `${environment.apiUrl}/v1/external/payments/payment-management/store-collector/${id}/pdf`;
      return this.http.get(endpoint, { responseType: 'blob' }).pipe(
        tap((response) => {
          downloadFile(`referencia-${id}.pdf`, response);
        })
      );
    }
    const endpoint = `${environment.apiUrl}/v1/external/payments/payment-management/store`;
    return this.http
      .post<SingleItemResponse<StorePaymentModel>>(`${endpoint}/${id}/pdf`, {})
      .pipe(
        tap((data: SingleItemResponse<StorePaymentModel>) => {
          window.open(data.data.url, '_blank');
        })
      );
  }

  public getAvailableStore(params: PaginationModel): Observable<StoresModel[]> {
    const endpoint = `${
      environment.apiUrl
    }/v1/external/payments/payment-stores${`?${new URLSearchParams(
      params as any
    ).toString()}`}`;
    return this.http.get<CollectionResponse<StoresModel>>(endpoint).pipe(
      map((response) => {
        return response.data.items;
      })
    );
  }
}
